import styled, { css } from "styled-components";
export const ButtonContainer = styled.button`
  border: none;
  border-radius: 5px;
  padding: 6px 24px;
  font-size: 20px;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  ${({ btn }) => {
    switch (btn) {
      case "primary":
        return css`
          background-color: ${({ theme }) => theme.colors.btnPrimaryBg};
          border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
          color: ${({ theme }) => theme.colors.btnPrimaryText};
          &:active {
            background-color: ${({ theme }) => theme.colors.btnPrimaryActive};
          }
        `;
      case "outline":
        return css`
          background-color: ${({ theme }) => theme.colors.btnOutLineBg};
          border: solid 1px ${({ theme }) => theme.colors.btnOutLineBorder};
          color: ${({ theme }) => theme.colors.btnOutLineText};
          &:active {
            background-color: ${({ theme }) => theme.colors.btnOutLineActive};
          }
        `;
      default:
        return css`
          background-color: ${({ theme }) => theme.colors.btnPrimaryBg};
          border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
          color: ${({ theme }) => theme.colors.btnPrimaryText};
          &:active {
            background-color: ${({ theme }) => theme.colors.btnPrimaryActive};
          }
        `;
    }
  }}
  @media only screen and (max-width: 760px) {
    padding: 8px 16px 6px 16px;
    font-size: 16px;
  }
`;
